module.exports = __webpack_public_path__ + "img/bg-phone.0.1.0_202310101542.png";